import React, { useState, useEffect } from "react";
import { useConfig, isDevLikeEnv } from "@crystal/config";
import { createABTestPayload } from "../lib/abtest-payload.js";
import { fetchMonetateData } from "../lib/api.js";
import { setMonetateIdCookie } from "../lib/utils.js";
import { ABTestingContext } from "./context.js";
const ABTestingProvider = ({ children }) => {
  const { env, locale, brand } = useConfig();
  const [monetateData, setMonetateData] = useState({});
  useEffect(() => {
    setMonetateIdCookie();
    getMonetateData().then((data) => {
      if (data.data) {
        setMonetateData(data);
      }
    });
  }, []);
  async function getMonetateData() {
    let abTestingDataFromApi;
    const body = createABTestPayload({ env, locale, brand });
    try {
      abTestingDataFromApi = await fetchMonetateData(body);
    } catch (err) {
      if (isDevLikeEnv(env)) {
        console.error(err);
      }
      abTestingDataFromApi = {};
    }
    return abTestingDataFromApi;
  }
  return /* @__PURE__ */ React.createElement(ABTestingContext.Provider, { value: { monetateData } }, children);
};
export {
  ABTestingProvider
};
//# sourceMappingURL=provider.js.map
